import { createContext, useContext } from 'react';

/**
 * Our own chrome (TopBar, agent badge, modals) renders inside a Shadow DOM
 * root for CSS isolation from the host page's theme — but the JBL/SUL
 * booking widgets are separate, independently-built apps that inject their
 * own CSS into document.head and look themselves up via plain
 * document.getElementById(), neither of which works across a shadow
 * boundary. Root.tsx portals <Outlet/> (View, containing those widgets) out
 * to this plain light-DOM element instead, so they keep working exactly as
 * they do standalone.
 */
const PortalTargetContext = createContext<HTMLElement | null>(null);

export const PortalTargetProvider = PortalTargetContext.Provider;

export const usePortalTarget = (): HTMLElement | null => useContext(PortalTargetContext);
